import config from "../config";
import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", config.defaultMessage, "RedirectError", "$step_name$", config.defaultMessageId)
